import React, { useState } from 'react';

import {
	FormItem,
	FormMessage,
	FormControl,
	FormLabel,
	FormField,
} from '@/components/ui/form';
import { useFormContext } from 'react-hook-form';
import IconEye from '@/components/icons/IconEye';

const PasswordField = () => {
	const [visible, setVisible] = useState(false);

	const form = useFormContext();
	const errors = form.formState.errors;

	return (
		<div className="mb-4">
			<FormField
				control={form.control}
				name="password"
				render={({ field }) => (
					<FormItem className="flex flex-col items-start ">
						<FormLabel>Password</FormLabel>

						<div
							className={`${
								errors.password ? 'border-red' : 'border-gray-04'
							} flex  w-full h-12 px-4 py-3 text-base font-normal leading-6 border rounded-lg outline-none border-gray-05 bg-background-primary placeholder:text-label-tertiary text-label-primary
              `}>
							<input
								type={visible ? 'text' : 'password'}
								className="w-full text-base font-normal leading-6 bg-background-primary placeholder:text-label-tertiary text-label-primary"
								placeholder="Password"
								{...field}
							/>

							<button
								type="button"
								onClick={() => setVisible(v => !v)}
								className="pl-2 cursor-pointer">
								<IconEye visible={visible} />
							</button>
						</div>
						<FormMessage />
					</FormItem>
				)}
			/>
		</div>
	);
};

export default PasswordField;
